import { UserButton } from "@clerk/react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { useCurrentUser } from "@/features/auth/useCurrentUser";
import {
  PublicFooter,
  PublicLogoMark,
} from "@/components/PublicMarketingLayout";

const navItems = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/projects", label: "Projects" },
  { to: "/tools", label: "Tools" },
  { to: "/pricing", label: "Pricing" },
];

export function AppShell() {
  const { user } = useCurrentUser();
  const visibleNavItems = user?.is_admin
    ? [...navItems, { to: "/admin", label: "Admin" }]
    : navItems;

  return (
    <div className="min-h-screen bg-slate-50 text-slate-950">
      <header className="sticky top-0 z-20 border-b border-indigo-100/80 bg-white/90 backdrop-blur">
        <div className="mx-auto flex w-full max-w-7xl items-center gap-4 px-4 py-3 sm:px-6 lg:px-8">
          <Link
            to="/dashboard"
            className="flex min-w-0 shrink-0 items-center gap-3 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            aria-label="Go to dashboard"
          >
            <PublicLogoMark />
            <span className="hidden min-w-0 sm:block">
              <span className="block truncate text-base font-bold tracking-tight text-slate-950">
                Alchemy Blueprint Engine
              </span>
              <span className="block text-xs font-semibold uppercase tracking-[0.18em] text-indigo-500">
                Blueprint Studio
              </span>
            </span>
          </Link>

          <nav className="flex flex-1 flex-wrap rounded-lg border border-slate-200 bg-slate-100 p-1">
            {visibleNavItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  [
                    "rounded-md px-3 py-1.5 text-sm font-medium transition",
                    isActive
                      ? "bg-white text-slate-950 shadow-sm"
                      : "text-slate-500 hover:text-slate-950",
                  ].join(" ")
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex shrink-0 items-center gap-3">
            <Link
              to="/blueprints/new"
              className="hidden rounded-xl bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:inline-flex"
            >
              Create blueprint
            </Link>
            <UserButton />
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-6xl px-4 py-8 sm:px-5">
        <Outlet />
      </main>

      <PublicFooter />
    </div>
  );
}
